import { render } from "./DocumentField.vue?vue&type=template&id=da8f0996"
import script from "./DocumentField.vue?vue&type=script&lang=js"
export * from "./DocumentField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__